import { useCallback, useRef } from "react";

/**
 * Impede que uma ação assíncrona rode em paralelo consigo mesma.
 *
 * O estado `loading` só desabilita o botão depois do re-render, então um duplo
 * clique rápido dispara o handler duas vezes. O ref muda na hora: a segunda
 * chamada encontra a ação em andamento e é ignorada.
 */
export const useInFlight = () => {
  const inFlight = useRef(false);

  const runOnce = useCallback(async action => {
    if (inFlight.current) return undefined;
    inFlight.current = true;
    try {
      return await action();
    } finally {
      inFlight.current = false;
    }
  }, []);

  return runOnce;
};
